
/**
 * 검색할 키워드 (강의 제목, 설명 등 대상)
 */
export type SearchTermParamParameter = string;
